import { jsxs as b, jsx as _ } from "react/jsx-runtime";
import { c as i, I as s } from "./Section-DOeCOW54.js";
import { forwardRef as h } from "react";
import { T as l } from "./useMediaQuery-BZAMobKw.js";
const a = "elo-checkbox", k = "elo-checkbox__label", p = "elo-checkbox__input__icon", u = "elo-checkbox__input", c = {
  checkbox: a,
  checkbox__label: k,
  checkbox__input__icon: p,
  checkbox__input: u,
  "checkbox__input--checked": "elo-checkbox__input--checked",
  "checkbox__input--disabled": "elo-checkbox__input--disabled",
  "checkbox__input--text-disabled": "elo-checkbox__input--text-disabled"
}, C = h(
  ({ label: t, checked: e = !1, disabled: o = !1, ...x }, n) => /* @__PURE__ */ b("div", { className: c.checkbox, children: [
    /* @__PURE__ */ b("label", { className: c.checkbox__label, children: [
      /* @__PURE__ */ _(
        "input",
        {
          className: i(
            c.checkbox__input,
            e && c["checkbox__input--checked"],
            o && c["checkbox__input--disabled"]
          ),
          type: "checkbox",
          ref: n,
          checked: e,
          "aria-label": `${t} checkbox`,
          disabled: o,
          ...x
        }
      ),
      e && /* @__PURE__ */ _(
        s,
        {
          className: c.checkbox__input__icon,
          name: "Check"
        }
      )
    ] }),
    /* @__PURE__ */ _(
      l,
      {
        type: "span",
        size: "medium",
        extraClass: i(
          o && c["checkbox__input--text-disabled"]
        ),
        children: t
      }
    )
  ] })
);
export {
  C
};
